<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>

<div class="container m-t-alt">
  <div class="columns">
    <div class="column is-10 is-offset-1">
      <div class="card has-background-white mb-6">
        <form [formGroup]="form" (submit)="submit(form.value)">
          <h1 class="title is-2 mt-6">
            Submit a metric to the Catalogue of Tools & Metrics for Trustworthy
            AI
          </h1>
          <div class="content is-small">
            <p class="mb-5">
              A metric aims to leverage a tool for trustworthy AI to achieve a
              specific goal in a specific context (e.g. using transparency tools
              for fraud prevention, bias-mitigation tools for disease detection,
              etc.)
            </p>
          </div>
          <div class="field mb-5">
            <label class="is-size-7" for="title-input"
              >Title of the Metric<span class="has-text-danger">*</span></label
            >
            <div class="control mb-0">
              <input
                class="input is-large"
                [ngClass]="{
                  'is-danger-bis': showErrors && invalidInputs.includes('title')
                }"
                type="text"
                formControlName="title"
                id="title-input"
                placeholder="Title of the metric..."
              />
            </div>
          </div>

          <div class="field mb-5">
            <label class="is-size-7"
              >Description<span class="has-text-danger">*</span></label
            >
            <p class="is-size-8 mt-0 mb-2">
              A description that provides an overview of the use case (maximum
              1000 words). Feel free to include images, graphs and charts to
              illustrate the use case as needed.
            </p>
            <div class="control mb-4">
              <app-rich-text-input
                uniqueId="content"
                placeholder="Overview on the usage (maximum 1000 words)..."
                (valueChanged)="onRichTextChanged($event.value, 'content')"
                [showErrors]="showErrors && invalidInputs.includes('content')"
                [maxWords]="1000"
                [required]="true"
              ></app-rich-text-input>
            </div>
          </div>

          <div class="field mb-5">
            <label class="is-size-7">Describe references of the metrics </label>
            <div class="control mb-4">
              <app-rich-text-input
                uniqueId="references"
                placeholder="Describe the metric by it's references..."
                (valueChanged)="onRichTextChanged($event.value, 'references')"
                [showErrors]="
                  showErrors && invalidInputs.includes('references')
                "
              ></app-rich-text-input>
            </div>
          </div>

          <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
            Metric resource and links
          </h3>
          <p
            class="is-size-8 mb-5 mt-0"
            [ngClass]="{
              'has-text-danger-bis mt-0 is-size-7':
                showErrors && invalidInputs.includes('links')
            }"
          >
            At least one of the following fields is required: Link to the
            metric's website, Github repository of the metric, Hugging Face
            repository, or the main reference.
          </p>

          <div class="field mb-5">
            <label class="is-size-7">Enter the Website URL </label>

            <div class="field mb-5">
              <div class="control mb-4">
                <input
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  class="input is-large"
                  type="text"
                  formControlName="websiteURL"
                  id="websiteURL-input"
                  placeholder="Enter the url of the metric website's..."
                />
              </div>
            </div>
          </div>
          <div class="field mb-6">
            <label class="is-size-7" for="main-reference-url-input"
              >Enter the main reference URL
            </label>

            <div class="control mb-4">
              <input
                [ngClass]="{
                  'is-danger-bis': showErrors && invalidInputs.includes('links')
                }"
                class="input is-large"
                type="text"
                formControlName="mainReferenceURL"
                id="main-reference-url-input"
                placeholder="Enter the url of the metric main reference's..."
              />
            </div>
          </div>
          <div class="field mb-5">
            <label class="is-size-7">Enter the Hugging Face URL </label>

            <div class="field mb-5">
              <div class="control mb-4">
                <input
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  class="input is-large"
                  type="text"
                  formControlName="huggingFaceURL"
                  id="hugging-face-URL-input"
                  placeholder="Enter the url of the metric huggingFace's..."
                />
              </div>
            </div>
          </div>
          <div class="field mb-5">
            <label class="is-size-7">Enter the Github URL </label>

            <div class="field mb-5">
              <div class="control mb-4">
                <input
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  class="input is-large"
                  type="text"
                  formControlName="githubLink"
                  id="github-URL-input"
                  placeholder="Enter the url of the metric github's..."
                />
              </div>
            </div>
          </div>

          <!-- Taxonomy groups. -->
          <ng-container *ngFor="let taxonomyGroup of taxonomyGroups">
            <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
              {{ taxonomyGroup.name }}
            </h3>
            <p class="mt-0 mb-2 is-size-6" *ngIf="taxonomyGroup.description">
              {{ taxonomyGroup.description }}
            </p>

            <div class="columns is-multiline mb-4">
              <div
                class="column is-6 pt-5 pb-0"
                *ngFor="let taxonomyInput of taxonomyGroup.taxonomies"
              >
                <label class="is-size-7" for="excerpt-input">{{
                  taxonomyInput.label
                }}</label>

                <app-multi-tags-input
                  [values]="taxonomyInput.options"
                  [addNewOptionFunction]="taxonomyInput.createFunction"
                  [placeholder]="taxonomyInput.placeholder"
                  (selectedValuesChanged)="
                    onTaxonomySelected($event, taxonomyInput.propName)
                  "
                  [maxSelectedItems]="taxonomyInput.maxSelectedItems || 99"
                  *ngIf="taxonomyInput.options"
                >
                </app-multi-tags-input>
              </div>
            </div>
            <hr class="my-6" />
          </ng-container>

          <!-- Submitter information -->
          <div class="columns">
            <div class="column is-6">
              <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
                Email<span class="has-text-danger">*</span>
              </h3>

              <div class="field mb-5">
                <label class="is-size-7 help my-1" for="email-input">
                  We will use this to contact you if we have any further
                  questions related to your submission and to allow you to make
                  updates. Your email will not be shared nor made public and we
                  will not use it for other purposes. See our
                  <a href="https://www.oecd.org/privacy/" target="_blank"
                    >privacy policy</a
                  >
                  for more information.</label
                >
                <div class="control mb-4">
                  <input
                    [ngClass]="{
                      'is-danger-bis':
                        showErrors && invalidInputs.includes('email')
                    }"
                    class="input is-large"
                    type="email"
                    formControlName="email"
                    id="email-input"
                    placeholder="your-email@organization.com"
                  />
                </div>
                <p
                  *ngIf="showErrors && invalidInputs.includes('email')"
                  class="has-text-danger-bis mt-0 is-size-7"
                >
                  A valid email is required.
                </p>
              </div>
            </div>
            <div class="column is-6">
              <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
                Submitter<span class="has-text-danger">*</span>
              </h3>

              <div class="field mb-5">
                <label class="is-size-7 help my-1" for="submitter-input">
                  Organisation or entity submitting the use case.</label
                >
                <div class="control mb-4">
                  <input
                    [ngClass]="{
                      'is-danger-bis':
                        showErrors && invalidInputs.includes('submitter')
                    }"
                    class="input is-large"
                    type="text"
                    formControlName="submitter"
                    id="submitter-input"
                    placeholder="Organisation or entity submitting the use case..."
                  />
                </div>
              </div>
            </div>
          </div>

          <hr class="my-6" />

          <div class="field mb-5">
            <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
              Disclosures for contributors
            </h3>
            <div class="control mb-4 mt-1">
              <label
                class="checkbox-input mr-4"
                for="consent-publication-delay-input"
              >
                Once you submit tools, metrics, or use cases, we will review
                them and, if accepted, post them online. Please understand that
                due to the sheer volume of submissions, the process may take
                several days and communicating about the status of each
                submission may not be possible.
                <span class="has-text-danger">*</span>
                <input
                  type="checkbox"
                  formControlName="consentPublicationDelay"
                  id="consent-publication-delay-input"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="control mb-4 mt-1">
              <label class="checkbox-input mr-4" for="consent-input">
                By checking this box, I certify that all information included in
                this Submission Form is true to the best of my knowledge and
                that OECD has the non-exclusive, sub-licensable right to
                publish, copy, reproduce, distribute, perform, translate, and
                make derivative works from the information and material
                provided. For more details, please see
                <a
                  href="https://www.oecd.org/termsandconditions/"
                  target="_blank"
                  >OECD's Terms and Conditions</a
                >
                and
                <a
                  href="https://oecd.ai/en/catalogue-disclosures"
                  target="_blank"
                  >Catalogue disclosures</a
                >. <span class="has-text-danger">*</span>
                <input
                  type="checkbox"
                  formControlName="consent"
                  id="consent-input"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <p
              *ngIf="showErrors && invalidInputs.includes('consent')"
              class="has-text-danger-bis mt-0 is-size-7"
            >
              Your consent is mandatory to submit the tool.
            </p>
          </div>

          <div class="has-text-center is-flex is-justify-content-center pt-5">
            <re-captcha
              formControlName="recaptchaReactive"
              required
              [siteKey]="captchaKey"
            ></re-captcha>
          </div>
          <div class="level">
            <div class="level-left">
              <p class="level-item is-size-7">
                After you click on 'Submit', the OECD Secretariat will review
                your submission. 
              </p>
            </div>
            <div class="level-right">
              <div class="level-item">
                <button
                  class="button is-link"
                  [ngClass]="{
                    'is-loading': loadingSubmit
                  }"
                >
                  Submit Metric
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-tools-catalogue-disclaimer></app-tools-catalogue-disclaimer>
